import { useLoadScript } from "@react-google-maps/api";

import { FC, useEffect, useMemo, useRef, useState } from "react";

// import { AddressSuggestion } from "@/components/GoogleAddressAutocomplete/types";
// import { useGoogleSuggestions } from "@/components/GoogleAddressAutocomplete/useGoogleSuggestions";
// import { useUqualSuggestions } from "@/components/GoogleAddressAutocomplete/useUqualSuggestions";
// import { Input, InputProps } from "@/components/Input";
// import { GOOGLE_MAPS_LIBRARIES_TO_USE } from "@/ui/constants/google-maps";
// import { STATIC_LOCATION_TYPE } from "@/ui/constants/staticMaps";
//  import { cx } from "@/ui/helpers";
 import { cx } from "../../../helpers";
// import { parseAddressToComponents } from "@/ui/helpers/string";
// import { useOutsideClick } from "@/ui/hooks/useOutsideClick";
// import { Address } from "@/ui/types/api/session";
// import { GoogleAutoCompleteResult } from "@/ui/types/google";

// import { useVariation } from "@/../packages/ab-testing/src/react/hooks";

  import styles from "./styles.module.css";
import { InputNew, InputProps } from "../InputNew";
import { GoogleAutoCompleteResult } from "../../../ModalClass/types";
import { AddressSuggestion } from "./types";
import { GOOGLE_MAPS_LIBRARIES_TO_USE } from "../../constants/google-maps";
import { useGoogleSuggestions } from "./useGoogleSuggestions";
import { useUqualSuggestions } from "./useUqualSuggestions";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import { STATIC_LOCATION_TYPE } from "../../constants/staticMaps";
import { Address } from "./types";
import { parseAddressToComponents } from "../../../helpers/string";
import React from "react";
import { Img } from "react-image";
import assetPath from "../../../utils/assets";
type Options = {
  getShortAddress: boolean;
};

type Props = {
  placeholder?: string;
  focusOnLoad?: boolean;
  optionsContainerClassName?: string;
  containerClassName?: string;
  onChange?(address: string): void;
  onSelectAddress?(addressResult?: GoogleAutoCompleteResult): void;
  onSuggestionsChange?(suggestions: AddressSuggestion[]): void;
  onLoadGoogle?(): void;
  fixedPositionedSuggestions?: boolean;
  noRoofTopCheck?: boolean;
  options?: Options;
  mapPinIcon?: boolean;
  value?: string;
  onBlur?(): void;
} & Omit<InputProps, "onChange" | "value">;

export const GoogleAddressAutocompleteNew: FC<Props> = ({
  className,
  placeholder,
  focusOnLoad = true,
  containerClassName,
  optionsContainerClassName,
  onChange,
  onSelectAddress,
  onSuggestionsChange,
  onLoadGoogle,
  fixedPositionedSuggestions,
  noRoofTopCheck = false,
  options,
  mapPinIcon = true,
  onBlur,
  ...inputProps
}) => {
  const { isLoaded: isGoogleMapsLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries: GOOGLE_MAPS_LIBRARIES_TO_USE,
  });
  const imgMapPin = assetPath('map-pin.svg');
  const addressInputElement = useRef<HTMLInputElement>(null);
  // const { value: roofTopAddressVariation } = useVariation(
  //   "rooftop-address",
  //   "Control",
  // );

   const shouldOnlyShowRooftops = true;// roofTopAddressVariation === "Test";

  // const { value: addressSuggestionsVariation } = useVariation(
  //   "address-suggestions",
  //   "Control",
  // );
  const canShowUqualSuggestions = true;// addressSuggestionsVariation !== "Control";
  const showUqualSuggestionsFirst = true;// addressSuggestionsVariation === "Test-1";

  const [value, setValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(true);

  useEffect(() => {
    if (inputProps.value) {
      setValue(inputProps.value);
    }
  }, [inputProps.value]);

  const {
    isPlacesAutocompleteReady,
    data: googleSuggestions,
    isLoading: isGoogleLoading,
    setAutoCompleteValue: setGoogleAutocompleteValue,
  } = useGoogleSuggestions({
    getShortAddress: options?.getShortAddress,
  });

  const {
    data: uqualSuggestions,
    isLoading: isUqualLoading,
    setUqualSearchValue,
  } = useUqualSuggestions();

  useEffect(() => {
    if (
      addressInputElement.current &&
      isPlacesAutocompleteReady &&
      focusOnLoad
    ) {
      // Have to focus the input field through a ref because
      // it is initially disabled until ready = true
      addressInputElement.current.focus();
    }
  }, [isPlacesAutocompleteReady, focusOnLoad]);

  useEffect(() => {
    if (isGoogleMapsLoaded) onLoadGoogle?.();
  }, [isGoogleMapsLoaded, onLoadGoogle]);

  useOutsideClick(addressInputElement, () => {
    setShowSuggestions(false);
  });

  const onInputChange = (val: string, shouldFetchAddresses = true) => {
    if (!val) onSelectAddress?.();

    setValue(val);
    setGoogleAutocompleteValue(val, shouldFetchAddresses);
    // if (canShowUqualSuggestions) {
      setUqualSearchValue(val, shouldFetchAddresses);
    // }
    setShowSuggestions(true);
    // only call onChange if an auto-suggestion not selected
    if (shouldFetchAddresses) onChange?.(val);
  };

  const handleClick = async (
    address: Address,
    locationType: string,
    googleAddressString: string,
    placeId?: string,
  ) => {
    const formattedAddressUnit = address.addressLine2 || "";

    const manualSelection =
      locationType !== STATIC_LOCATION_TYPE && !noRoofTopCheck;

    const fieldAddress = manualSelection ? value : googleAddressString;
    const fieldUnit = manualSelection ? "" : formattedAddressUnit;

    const addressToSend: Address = manualSelection
      ? await parseAddressToComponents(fieldAddress, fieldUnit)
      : address;

    const addressResult = {
      address: String(fieldAddress),
      unit: fieldUnit,
      addressToSend,
      placeId: placeId || "",
    };

    onSelectAddress?.(addressResult);
    onInputChange(googleAddressString, false);
    setShowSuggestions(false);
  };

  const addressSuggestions = useMemo(() => {
    if (!canShowUqualSuggestions) {
      return googleSuggestions ?? [];
    } else if (showUqualSuggestionsFirst) {
      if (isUqualLoading) return [];
      else if (uqualSuggestions?.length) return uqualSuggestions;
      else return googleSuggestions ?? [];
    } else {
      if (isGoogleLoading) return [];
      else if (googleSuggestions?.length) return googleSuggestions;
      else return uqualSuggestions ?? [];
    }
  }, [
    googleSuggestions,
    isGoogleLoading,
    uqualSuggestions,
    isUqualLoading,
    canShowUqualSuggestions,
    showUqualSuggestionsFirst,
  ]);

  useEffect(() => {
    onSuggestionsChange?.(addressSuggestions);
  }, [addressSuggestions]);

  const renderSuggestions = () => {
    let filteredSuggestions =
      shouldOnlyShowRooftops && !noRoofTopCheck
        ? addressSuggestions.filter(
            address => address.locationType === STATIC_LOCATION_TYPE,
          )
        : addressSuggestions;

    return filteredSuggestions.map(suggestion => {
      const { address, locationType, mainText, googlePostalCode, placeId } =
        suggestion;

      const city = address.city ? `${address.city},` : "";
      const addressLine = mainText ? `${mainText},` : "";
      const postalCode = address.postalCode || googlePostalCode;

      const secondaryText = [city, address.state, postalCode]
        .filter(Boolean)
        .join(" ");

      const googleAddressString = [addressLine, secondaryText]
        .filter(Boolean)
        .join(" ");

      return (
        <li
          className={cx(styles.suggestion)}
          key={`${mainText} ${secondaryText}`}
          onClick={() =>
            handleClick(address, locationType, googleAddressString, placeId)
          }
        >
          <Img
            src={imgMapPin}
            width={16}
            height={16}
            alt="location"
            className={
              styles.pinIcon
            }
          />
          <span>
            <span>{mainText}</span> <small>{secondaryText}</small>
          </span>
        </li>
      );
    });
  };

  return (
    <div className={cx(
        styles.googleAutocompleteWrapper, 
      containerClassName)}>
      <InputNew
        ref={addressInputElement}
        value={value}
        className={cx(
            styles.autocompleteInput, 
          className)}
        loading={!isGoogleMapsLoaded || !isPlacesAutocompleteReady}
        onChange={e => {
          onInputChange(e.target.value);
        }}
        placeholder={placeholder}
        onFocus={() => setShowSuggestions(true)}
        autoComplete="off"
        data-cy="google-autocomplete-input"
        mapPinIcon={mapPinIcon}
        onBlur={onBlur}
        {...inputProps}
      />

      <div
        className={cx(!fixedPositionedSuggestions
           &&
           styles.suggestionsOuter
          )}
      >
        {showSuggestions && (
          <ul
            data-cy="google-autocomplete-suggestions"
            className={cx(
                styles.suggestionsContainer,
              fixedPositionedSuggestions &&
                styles.fixedPositionedSuggestionsContainer,
              optionsContainerClassName,
            )}
          >
            {renderSuggestions()}
          </ul>
        )}
      </div>
    </div>
  );
};


